import { render, staticRenderFns } from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=template&id=28b1bd90&scoped=true&"
import script from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditContactsMatchCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1bd90",
  null
  
)

export default component.exports